import React from 'react';
import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import SlideBanner from '@components/common/SlideBanner/SlideBanner';
import NewsNavPress from '@components/NewsPress/NewsNavPress';
import NewsListPress from '@components/NewsPress/NewsListPress';
import {NextSeo} from 'next-seo';
import NewsService from '@services/news.service';
import {generatePressListSEO} from '@helper/seo/generators/news';

export default function BaoChiNoiVeTNH(props) {
    const {locale} = useRouter();
    const {seoPage} = props;
    
    return (
        <>
            {seoPage && <NextSeo {...seoPage} />}
            <div>
            <SlideBanner titleBanner={getLocaleContent(locale, 'page.press-news.page-title')} />
            <NewsNavPress />
            <NewsListPress />
        </div>
        </>
    );
}

BaoChiNoiVeTNH.getInitialProps = async (context) => {
    try {
        const ctx = context || {};
        const webUrl = process.env.NEXT_PUBLIC_WEB_URL || process.env.WEB_URL || 'https://tnh.com.vn';
        
        // Fetch data thực tế từ API
        let pressArticles = [];
        let totalCount = 0;
        try {
            const newsService = new NewsService(ctx);
            
            // Lấy category báo chí
            const categoriesResponse = await newsService.getNewsCategoryList({
                locale: ctx.locale || 'vn'
            });
            
            let categoryList = [];
            if (categoriesResponse) {
                if (Array.isArray(categoriesResponse)) {
                    categoryList = categoriesResponse;
                } else if (categoriesResponse.categoryList && Array.isArray(categoriesResponse.categoryList)) {
                    categoryList = categoriesResponse.categoryList;
                } else if (categoriesResponse.data && Array.isArray(categoriesResponse.data)) {
                    categoryList = categoriesResponse.data;
                }
            }
            
            // Tìm category báo chí
            const pressCategory = categoryList.find(cat => 
                cat.news_category_name?.toLowerCase().includes('báo chí') || 
                cat.news_category_name?.toLowerCase().includes('press') ||
                cat.news_category_name?.toLowerCase().includes('báo chí nói về')
            );
            
            if (pressCategory) {
                // Lấy danh sách bài viết báo chí (lấy khoảng 15-20 items đầu để tạo SEO)
                const pressResponse = await newsService.getNewsList({
                    locale: ctx.locale || 'vn',
                    pageSize: 20,
                    pageIndex: 1,
                    news_category_id: pressCategory.news_category_id
                });
                
                // Xử lý response structure
                if (pressResponse) {
                    // Lấy total count
                    if (pressResponse.total !== undefined) {
                        totalCount = parseInt(pressResponse.total) || 0;
                    } else if (pressResponse.totalCount !== undefined) {
                        totalCount = parseInt(pressResponse.totalCount) || 0;
                    }
                    
                    // Lấy danh sách articles
                    if (Array.isArray(pressResponse)) {
                        pressArticles = pressResponse;
                    } else if (pressResponse.items && Array.isArray(pressResponse.items)) {
                        pressArticles = pressResponse.items;
                    } else if (pressResponse.data && Array.isArray(pressResponse.data)) {
                        pressArticles = pressResponse.data;
                    } else if (pressResponse.newsList && Array.isArray(pressResponse.newsList)) {
                        pressArticles = pressResponse.newsList;
                    }
                }
            }
        } catch (err) {
            console.error('Failed to fetch press news data for SEO:', err);
        }
        
        // Tạo SEO từ data thực tế
        const seoPage = generatePressListSEO(pressArticles, totalCount, webUrl);
        
        return {seoPage};
    } catch (error) {
        console.error('Failed to fetch SEO for press news page:', error);
        const webUrl = process.env.NEXT_PUBLIC_WEB_URL || process.env.WEB_URL || 'https://tnh.com.vn';
        // Fallback SEO
        const seoPage = generatePressListSEO([], 0, webUrl);
        return {seoPage};
    }
};
